<script setup>
import { ref, defineExpose, inject, watch, computed } from "vue"
import customFieldCom from "./common/customField.vue";
import { useRoute } from "vue-router";
import { getLangValueByKey } from "@/utils/common"; //获取后端语言
const detailInfo = inject('detailInfo')
const tabList = inject('tabList')
const current_tab = inject('current_tab')
const currentTabLang = inject('currentTabLang') //切换语言
const mykey = ref('')
const customFieldComRef = ref(null)
const route = useRoute()
//自定义字段list 底部
const customFieldsList = ref([
    {
        name: getLangValueByKey('product-template.template_text'), // 文本名称
        name_en: getLangValueByKey('product-template.template_text', 'en'), // 文本名称
        fieldsList: [
            {
                name: getLangValueByKey('product-template.template_text_field'), //字段名称
                name_en: getLangValueByKey('product-template.template_text_field', 'en'), //字段名称
                unit: '', //字段单位
                key: '字段1',
            },
            // {
            //     name: '字段2', //字段名称
            //     unit: '', //字段单位
            //     key: '字段2',
            // },
            // {
            //     name: '字段3', //字段名称
            //     unit: '', //字段单位
            //     key: '字段3',
            // },
        ],
        isShow: false,
        showUpload: false,
        showDelete: true,
    },
    {
        name: getLangValueByKey('product-template.template_text_attachment'), // 文本名称 
        name_en: getLangValueByKey('product-template.template_text_attachment', 'en'), // 文本名称 
        fieldsList: [
            {
                name: getLangValueByKey('product-template.template_text_field'), //字段名称
                name_en: getLangValueByKey('product-template.template_text_field', 'en'), //字段名称
                unit: '', //字段单位
                key: '字段1',
            },
            // {
            //     name: '字段2', //字段名称
            //     unit: '', //字段单位
            //     key: '字段2',
            // },
            // {
            //     name: '字段3', //字段名称
            //     unit: '', //字段单位
            //     key: '字段3',
            // },
        ],
        isShow: false,
        showUpload: true,
        showDelete: true,
        id: 'otherInfoFiledUpload',
        accept: '', // 接受的类型
        fileList: [],
        fileMaxSize: 1024 * 1024 * 200, //200M
    }
])
const customFieldsListShowLen = ref(computed(() => customFieldsList.value.filter(item => item.isShow).length))
// 自定义字段校验
const checkForm = () => {
    let flag = true
    for (let k in customFieldsList.value) {
        if (!customFieldsList.value[k].name) {
            flag = false
            currentTabLang.value =1;
            break
        }
        if (!customFieldsList.value[k].name_en) {
            flag = false
            currentTabLang.value =2;
            break
        }
    }
    return flag
}
// 筛选出重复项
const findDuplicates = (arr) => {
    const map = new Map();
    const duplicates = arr.filter(item => {
        if (!map.has(item)) {
            map.set(item, 1);
            return false;
        } else {
            map.set(item, map.get(item) + 1);
            return true;
        }
    });
    return duplicates;
};

// check 每个模板名称是否重复
const checkRepeat2 = () => {
    let checkRes1 = true;
    let arr = []
    let arr1 = []
    let moduleName = ''
    // 上传框
    for (let k in customFieldsList.value) {
        if (customFieldsList.value[k].isShow) {
            arr.push(customFieldsList.value[k].name);
            arr1.push(customFieldsList.value[k].name_en);
        }
    }
    // 去重
    // console.log(arr);
    let uniqueArr = Array.from(new Set(arr))
    let uniqueArr1 = Array.from(new Set(arr1))
    // console.log(uniqueArr);
    if (uniqueArr.length != arr.length) {
        // 重复名称
        const duplicates = findDuplicates(arr);
        moduleName = duplicates.join(',');
        checkRes1 = false
        currentTabLang.value =1;
    }
    if (uniqueArr1.length != arr1.length) {
        // 重复名称
        const duplicates = findDuplicates(arr1);
        moduleName = duplicates.join(',');
        checkRes1 = false
        currentTabLang.value =2;
    }
    return { checkRes1, moduleName }
}


// 监听detailInfo 组装数据
watch(detailInfo, (val) => {
    //设置自定义字段list
    // console.log(val);
    const { extra_info } = val
    if (typeof extra_info == 'undefined') return
    const etrList = extra_info.children.filter(item => item.extra && (item.extra.myKey == '文本项' || item.extra.myKey == "文本项+附件项"))
    // console.log(extra_info.children)
    if (etrList.length) {
        customFieldsList.value = etrList.map(item => {
            let m = {
                name: item.name, // 文本名称
                name_en: item.name_en, // 文本名称
                fieldsList: [],
                showUpload: false,
                showDelete: true,
                isShow: item.show,
            }
            if (item.children)
                m.fieldsList = item.children.map(ele => {
                    return {
                        name: ele.name, //字段名称
                        name_en: ele.name_en, //字段名称
                        unit: ele.unit, //字段单位
                        key: ele.key,
                        value: '',
                        required: ele.required
                    }
                })
            if (item.extra.myKey == "文本项+附件项") {
                m.showUpload = item.extra.showUpload
                m.showDelete = item.extra.showDelete
                m.id = item.extra.id
                m.accept = item.extra.accept
                m.fileList = item.extra.fileList
                m.fileMaxSize = item.extra.fileMaxSize
            }
            return m
        })
        mykey.value = new Date().getTime()
        // console.log(customFieldsList.value);
    } else {
        customFieldsList.value = [];
    }
},)

// 监听数据 如果数据长度为0  则不显示tab
watch(() => customFieldsList.value.length, (val) => {
    if (val == 0) {
        // console.log(tabList);
        tabList.value[tabList.value.length - 1].show = false;
        current_tab.value = 0
    }
})

watch(customFieldsListShowLen, (val) => {
    // console.log(val);
    if (val == 0 && route.query.type == 'view') {
        // console.log(tabList);
        tabList.value[tabList.value.length - 1].show = false;
        current_tab.value = 0
    }
}, {immediate:true})

defineExpose({
    customFieldsList,
    checkForm,
    checkRepeat2
})

</script>
<template>
    <!-- 自定义字段及上传 -->
    <customFieldCom v-model:customFieldsList="customFieldsList" ref="customFieldComRef" :key="mykey" />
</template>
<style scoped></style>